import request from '../../../util/request';

export const postAuthenticateApi = data =>
  request.post('/crm/crmUserLogin', data);
export const postRegisterApi = data =>
  request.post('/crm/registerHbUser', data);

export const logoutApi = () => request.post('/crm/crmUserLogout');
